import { shareLink } from '@/utils';

export const getReferralUrl = (code: string): string => `${window.location.origin}/r/${code}`;

export async function shareReferralLink({
	url,
	message,
}: {
	url: string;
	message: string;
}): Promise<void> {
	return shareLink({ url, message });
}
